import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionContextService } from '../context/session-context.service';

import { Campaign } from '../models/campaign.model';
import { Municipality } from '../models/municipality.model';

@Injectable({
  providedIn: 'root'
})
export class DataProvider {

  // PRIVATE _variables - Listado de variables dónde almacenar los datos maestros.
  private _etiquetadores;
  private _campaigns: Campaign[];
  private _municipalities: Municipality[];
  private _allMunicipios: Municipality[];
  private _resultadosList = [{ id: 1, des: 'Pendiente' }, { id: 2, des: 'Positivo' }, { id: 3, des: 'Negativo' }];
  private _estadosInspeccionList = [{ id: 1, des: 'En curso' }, { id: 2, des: 'No finalizada' }, { id: 3, des: 'Finalizada' }];
  private _rolesNotificacion = [{ id: 2, des: 'Entidad Control' }, { id: 3, des: 'Etiquetador' }];
  private _aplicacion;
  private _tiposFruta;
  private _empresasCorte;
  private _tiposVegetacion;
  private _tiposAnomalia;
  private _denominaciones;
  private _municipiosConDesignacion: Municipality[];
  private _municipiosConCortes: Municipality[];
  private _idiomas;
  private _paises;
  private _etiquetas;
  private _grupoEtiquetas;
  private _productos;
  private _marcas;
  private _cultivos;
  private _timeZones;
  private _etiquetadoresPais;
  private _unidadesMedida;
  private _destinos;
  private _entidadesControl;
  private _yesNo;
  private _confirmacionesPendientes;
  private _tiposConfeccion;
  private _tiposConsumo;
  private _estadosIncidencia;
  private _tiposIncidencia;
  private _unidadesAfectadas;
  private _anyosCampanya;
  private _unidadesPesoRoyalties;
  private _unidadesDivisasRoyalties;
  private _unidadesSuperficieRoyalties;
  private _unidadesNPlantasRoyalties;
  private _estadosProteccion;
  private _alertasEmail;
  private _alertasReimpresionSnc;
  private _alertasRangoPorcentaje; // tanto para emails sobre núm. de reimpresiones como excesos en Designaciones
  private _bloqueoPorcentajes;

  constructor(private _http: HttpClient,
    public ts: TranslateService,
    private readonly _sessionContext: SessionContextService) { }

  // LOAD() - Listado de las operaciones que se cargarán en el inicio de sesión.
  public load() {

    let promises: Promise<any>[] = [];
    promises.push(this.getEtiquetadores());
    promises.push(this.getTimeZones());
    promises.push(this.getDenominaciones());
    promises.push(this.getIdiomas());
    promises.push(this.getProductos());
    promises.push(this.getMarcas());
    promises.push(this.getEtiquetadoresPais());
    promises.push(this.getAnyosCampanya());

    switch (this._sessionContext.sessionUser.role) {
      case 'Etiquetador':
        break;
      case 'Auditor':
      case 'Supervisor':
        promises.push(this.getEntidadesControl());
        break;
      default:
        promises.push(this.getEtiquetas());
        promises.push(this.getGrupoEtiquetas());
        promises.push(this.getEntidadesControl());
        break;
    }

    let filtersPais = {
      esProductor: true
    };
    promises.push(this.getPaises(filtersPais));
    promises.push(this.getAllDestinos());

    return Promise.all(promises).then(
      (values) => {
        this._etiquetadores;
        this.refreshTranslations();
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshTranslations() {
    this._aplicacion = [
      { des: this.ts.instant('gestionLicencias.licencia.aplicacion.denominaciones'), id: 1 }
      // Pendiente: { des: this.ts.instant('gestionLicencias.licencia.aplicacion.etiquetado'), id: }
    ]

    this._yesNo = [
      { des: this.ts.instant("global.si"), value: true, id: 1 },
      { des: this.ts.instant("global.no"), value: false, id: 2 }
    ];

    this._confirmacionesPendientes = [
      { des: this.ts.instant("gestionLicencias.licencia.tiempos.nunca"), value: "00:00:00", id: 0 },
      { des: this.ts.instant("gestionLicencias.licencia.tiempos.cinco"), value: "00:05:00", id: 5 },
      { des: this.ts.instant("gestionLicencias.licencia.tiempos.quince"), value: "00:15:00", id: 15 },
      { des: this.ts.instant("gestionLicencias.licencia.tiempos.treinta"), value: "00:30:00", id: 30 }
    ];

    this._tiposConfeccion = [
      { des: this.ts.instant('disenyo-etiquetas.filters.tipoConfeccion.caja'), value: "1", id: 1 },
      { des: this.ts.instant('disenyo-etiquetas.filters.tipoConfeccion.pallet'), value: "2", id: 2 }
    ];

    this._tiposConsumo = [
      { des: this.ts.instant('mantenimientoIncidencias.filters.consumo.estandar'), value: "0", id: 0 },
      { des: this.ts.instant('mantenimientoIncidencias.filters.consumo.mix'), value: "1", id: 1 }
    ];

    this._estadosIncidencia = [
      { des: this.ts.instant('mantenimientoIncidencias.filters.estado.gestionada'), value: true, id: 1 },
      { des: this.ts.instant('mantenimientoIncidencias.filters.estado.noGes'), value: false, id: 2 }
    ];

    this._tiposIncidencia = [
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option1'), value: 1, id: 1 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option2'), value: 2, id: 2 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option3'), value: 6, id: 6 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option4'), value: 7, id: 7 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option5'), value: 8, id: 8 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option6'), value: 9, id: 9 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.tipoIncidencia.option7'), value: 10, id: 10 }
    ];

    this._unidadesAfectadas = [
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.unidadesAfectadas.option1'), value: 1, id: 1 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.unidadesAfectadas.option2'), value: 2, id: 2 },
      { des: this.ts.instant('mantenimientoIncidencias.incidencia.unidadesAfectadas.option3'), value: 3, id: 3 },
    ];

    this._unidadesPesoRoyalties = [
      { id: 1, des: this.ts.instant('unidadesMedidaRoyalties.kilogramos'), symbol: "Kg", default: true },
      { id: 2, des: this.ts.instant('unidadesMedidaRoyalties.stems'), symbol: "Stems" },
      { id: 3, des: this.ts.instant('unidadesMedidaRoyalties.pounds'), symbol: "lb" }
    ];

    this._unidadesDivisasRoyalties = [
      { id: 1, des: this.ts.instant('unidadesMedidaRoyalties.euro'), symbol: "€", default: true },
      { id: 2, des: this.ts.instant('unidadesMedidaRoyalties.dolar'), symbol: "$" }
    ];

    this._unidadesNPlantasRoyalties = [
      { id: 1, des: this.ts.instant('unidadesMedidaRoyalties.unidad'), symbol: this.ts.instant('unidadesMedidaRoyalties.unidad'), default: true },
      { id: 2, des: this.ts.instant('unidadesMedidaRoyalties.millar'), symbol: this.ts.instant('unidadesMedidaRoyalties.millar') }
    ];

    this._unidadesSuperficieRoyalties = [
      { id: 1, des: this.ts.instant('unidadesMedidaRoyalties.hectareas'), symbol: "ha", default: true }
    ];

    this._estadosProteccion = [
      { id: 1, des: this.ts.instant('mantenimientoDenominaciones.proteccion.table.estado.active') },
      { id: 2, des: this.ts.instant('mantenimientoDenominaciones.proteccion.table.estado.expired') },
      { id: 3, des: this.ts.instant('mantenimientoDenominaciones.proteccion.table.estado.revoked') }
    ];

    this._alertasEmail = [
      { des: this.ts.instant('emailSubscription.notSend'), id: 0 },
      { des: this.ts.instant('emailSubscription.last') + ' ' + this.ts.instant('emailSubscription.day'), id: 1 },
      { des: this.ts.instant('emailSubscription.lastPlural') + ' 2 ' + this.ts.instant('emailSubscription.days'), id: 2 },
      { des: this.ts.instant('emailSubscription.lastPlural') + ' 3 ' + this.ts.instant('emailSubscription.days'), id: 3 },
      { des: this.ts.instant('emailSubscription.lastPlural') + ' 4 ' + this.ts.instant('emailSubscription.days'), id: 4 },
      { des: this.ts.instant('emailSubscription.lastPlural') + ' 5 ' + this.ts.instant('emailSubscription.days'), id: 5 },
      { des: this.ts.instant('emailSubscription.lastPlural') + ' 6 ' + this.ts.instant('emailSubscription.days'), id: 6 },
      { des: this.ts.instant('emailSubscription.lastPlural') + ' 7 ' + this.ts.instant('emailSubscription.days'), id: 7 },
    ];

    this._alertasReimpresionSnc = [
      { des: this.ts.instant('emailSubscription.notReport'), id: 0 },
      { des: this.ts.instant('emailSubscription.from') + ' 2', id: 2 },
      { des: this.ts.instant('emailSubscription.from') + ' 3', id: 3 },
      { des: this.ts.instant('emailSubscription.from') + ' 4', id: 4 },
      { des: this.ts.instant('emailSubscription.from') + ' 5', id: 5 },
    ];

    this._alertasRangoPorcentaje = [
      { des: this.ts.instant('emailSubscription.notReport'), id: 0 },
      { des: '5%', id: 5 },
      { des: '10%', id: 10 },
      { des: '15%', id: 15 },
      { des: '20%', id: 20 },
      { des: '25%', id: 25 },
    ];

    this._bloqueoPorcentajes = [
      { id: 0, des: this.ts.instant('global.noBloquear'), value: false },
      { id: 1, des: this.ts.instant('global.bloquear'), value: true }
    ];
  }

  public refreshEntidadControl() {
    let promises: Promise<any>[] = [];
    promises.push(this.getEntidadesControl());

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshEmpacadores() {
    let promises: Promise<any>[] = [];
    promises.push(this.getEtiquetadores());

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshDenominaciones() {
    let promises: Promise<any>[] = [];
    promises.push(this.getDenominaciones());

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshPaises() {
    let filtersPais = {
      esProductor: true
    };
    let promises: Promise<any>[] = [];
    promises.push(this.getPaises(filtersPais));

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshDisenyos() {
    let promises: Promise<any>[] = [];
    promises.push(this.getEtiquetas());

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshProductos() {
    let promises: Promise<any>[] = [];
    promises.push(this.getProductos());

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  public refreshMarcas() {
    let promises: Promise<any>[] = [];
    promises.push(this.getMarcas());

    return Promise.all(promises).then(
      (values) => {
        console.log("Promise all finished: " + values);
        return true;
      }
    );
  }

  // PUBLIC GET function() - Apartado para el acceso a los datos recuperados, sólo lectura.
  public get etiquetadores() {
    return this._etiquetadores;
  }

  public get campaigns() {
    return this._campaigns;
  }

  public get municipalities() {
    return this._municipalities;
  }

  public get allMunicipios() {
    return this._allMunicipios;
  }

  public get municipiosConDesignacion() {
    return this._municipiosConDesignacion;
  }

  public get municipiosConCortes() {
    return this._municipiosConCortes;
  }

  public get resultadosList() {
    return this._resultadosList;
  }

  public get rolesNotificacion() {
    return this._rolesNotificacion;
  }

  public get estadosInspeccionList() {
    return this._estadosInspeccionList;
  }

  public get aplicacion() {
    return this._aplicacion;
  }

  public get tiposFruta() {
    return this._tiposFruta;
  }

  public get empresasCorte() {
    return this._empresasCorte;
  }

  public get tiposVegetacion() {
    return this._tiposVegetacion;
  }

  public get tiposAnomalia() {
    return this._tiposAnomalia;
  }

  public get denominaciones() {
    return this._denominaciones;
  }

  public get idiomas() {
    return this._idiomas;
  }

  public get paises() {
    return this._paises;
  }

  public get etiquetas() {
    return this._etiquetas;
  }

  public get grupoEtiquetas() {
    return this._grupoEtiquetas;
  }

  public get productos() {
    return this._productos;
  }

  public get marcasPaisDenominacion() {
    return this._marcas;
  }

  public get cultivos() {
    return this._cultivos;
  }
  public get timeZones() {
    return this._timeZones;
  }

  public get etiquetadoresPais() {
    return this._etiquetadoresPais;
  }

  public get unidadesMedida() {
    return this._unidadesMedida;
  }

  public get destinos() {
    return this._destinos;
  }

  public get marcas() {
    return this._marcas;
  }

  public get entidadesControl() {
    return this._entidadesControl;
  }

  public get yesNo() {
    return this._yesNo;
  }

  public get confirmacionesPendientes() {
    return this._confirmacionesPendientes;
  }

  public get tiposConfeccion() {
    return this._tiposConfeccion;
  }

  public get tiposConsumo() {
    return this._tiposConsumo;
  }

  public get estadosIncidencia() {
    return this._estadosIncidencia;
  }

  public get tiposIncidencia() {
    return this._tiposIncidencia;
  }

  public get etqAfectadas() {
    return this._unidadesAfectadas;
  }

  public get anyosCamanya() {
    return this._anyosCampanya;
  }

  public get unidadesPesoRoyalties() {
    return this._unidadesPesoRoyalties;
  }

  public get unidadesDivisasRoyalties() {
    return this._unidadesDivisasRoyalties;
  }

  public get unidadesSuperficieRoyalties() {
    return this._unidadesSuperficieRoyalties;
  }

  public get unidadesNPlantasRoyalties() {
    return this._unidadesNPlantasRoyalties;
  }

  public get estadosProteccion() {
    return this._estadosProteccion;
  }

  public get alertasEmail() {
    return this._alertasEmail;
  }

  public get alertasReimpresionSnc() {
    return this._alertasReimpresionSnc;
  }

  public get alertasRangoPorcentaje() {
    return this._alertasRangoPorcentaje;
  }
  
  public get bloqueoPorcentajes() {
    return this._bloqueoPorcentajes;
  }

  // PRIVATE function() - RECUPERACIÓN DE DATOS - Llamadas a realizar en el inicio de sesión.
  private getEtiquetadores(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Etiquetador/GetAll').subscribe((resp) => {
        this._etiquetadores = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getDenominaciones() {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Denominacion/GetAll').subscribe((resp) => {
        this._denominaciones = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getIdiomas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Idioma/GetAll').subscribe((resp) => {
        // filterable-list necesita la clave id (evitar tenerla duplicada)
        this._idiomas = resp.map((lang: any) => {
          const langId = lang.idiomaId;
          delete lang.idiomaId;
          return { ...lang, id: langId };
        });
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getPaises(filters): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters).subscribe((resp) => {
        this._paises = resp.lista;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getEtiquetas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/DisenyoEtiqueta/GetAll').subscribe((resp) => {
        this._etiquetas = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getGrupoEtiquetas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAll').subscribe((resp) => {
        this._grupoEtiquetas = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getProductos(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Producto/GetAll').subscribe((resp) => {
        this._productos = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getMarcas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Marca/GetAll').subscribe((resp) => {
        this._marcas = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getTimeZones(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Info/GetMsTimeZonesId').subscribe((resp) => {
        this._timeZones = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getEtiquetadoresPais(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Etiquetador/GetEtiquetadorConPaisesAsociados').subscribe((resp) => {
        this._etiquetadoresPais = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getAllDestinos() {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Pais/GetAllPaisesDestino').subscribe((resp) => {
        this._destinos = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getEntidadesControl(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/EntidadControl/GetAll').subscribe((resp) => {
        this._entidadesControl = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }

  private getAnyosCampanya(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._http.get<any>(environment.apiEndpoint + '/Campanya/GetAnyosConCampanya').subscribe((resp) => {
        this._anyosCampanya = resp;
        setTimeout(resolve, 1);
      }, (error) => {
        setTimeout(resolve, 1);
      });
    });
  }
}


